<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <h2>
          {{ displayName }}
          <a class="btn btn-sm" @click="$emit('reset-farm')">(Change farm)</a>
        </h2>

        <div class="panel-body">
          <form v-on:submit.prevent="onSubmit">
            <div v-if="!searching">
              <input type="submit" class="btn btn-primary" value="Generate" />
              <template v-if="hasData">
                | <a :href="exportUrl" target="_blank" class="btn btn-success">Download as PDF</a>
              </template>
            </div>
            <div v-else>
              <img
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
            </div>
          </form>
        </div>
      </div>
    </div>

    <br />

    <div v-if="hasData">
      <div>
        <h4>
          THIS IS NOT AN AUTHORISATION - for full RVM information please refer to the corresponding veterinary
          authorisation
        </h4>
        <h2>Antibiotic & Anti-inflammatory Combinations</h2>
        <h3 class="lightblue">For NZCP1 Audit Purposes ONLY</h3>
        <table class="table-bordered table">
          <tbody>
            <tr>
              <td class="thead">Farm Name:</td>
              <td>{{ headers.farm_name }}</td>
              <td class="thead">Dairy Number:</td>
              <td>{{ headers.supply }}</td>
              <td class="thead">Valid for Authorisation Dated:</td>
              <td>{{ headers.consult_date }}</td>
            </tr>
          </tbody>
        </table>
        <br />

        <template v-if="groups">
          <table class="table table-bordered combos-table">
            <thead>
              <tr>
                <th class="text-center thead">
                  GROUP A <br />
                  Authorised Intramammary Antibiotics
                </th>
                <th class="text-center thead">
                  GROUP B <br />
                  Authorised Injectable Antibiotics
                </th>
                <th class="text-center thead">
                  GROUP C <br />
                  Authorised Anti-Inflammatories
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='(row, index) in drugs_per_row' :key='`drugsrow_${index}`'>
                <td>{{row.A}}</td>
                <td>{{row.B}}</td>
                <td>{{row.C}}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>No drug combinations</template>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="2" class="thead">
                When administering more than one authorised Restricted Veterinary Medicine (RVM) on the same day, use
                the following withholding periods:
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 30%" class="text-right">
                <strong> Group A with Group C: </strong>
              </td>
              <td class="text-left">
                Apply the label withholding period from whichever of the two products that results in the latest
                return-to-vat date
              </td>
            </tr>
            <tr>
              <td style="width: 30%" class="text-right">
                <strong> Group B with Group C: </strong>
              </td>
              <td class="text-left">
                Apply the label withholding period from whichever of the two products that results in the latest
                return-to-vat date
              </td>
            </tr>
            <tr>
              <td style="width: 30%" class="text-right">
                <strong>Group A with Group B:</strong>
              </td>
              <td class="text-left">
                Apply the label withholding period from whichever of the two products that results in the latest
                return-to-vat date
                <strong>plus</strong> an extra 24 hours
              </td>
            </tr>
            <tr>
              <td style="width: 30%" class="text-right">
                <strong>Group A & Group B & Group C:</strong>
              </td>
              <td class="text-left">
                Apply the label withholding period from whichever of the three products that results in the latest
                return-to-vat date
                <strong>plus</strong> an extra 24 hours
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-left">
                <strong><u>Oxytocin</u></strong> products such as Oxytocin V & Butocin can be used in combination with
                drugs from all groups - A, B & C, and the longest withholds apply (the cow MUST have calved before
                using).
                <br />
                <strong>
                  <u>Changing RVM Treatments:</u> If a different RVM is not administered on the same day, but is
                  administered during the <u>withholding period of another RVM</u>, then there is NO CHANGE to the
                  withholding periods of the products used. Use the withhold period that results in the latest
                  return-to-vat date.
                  <br />
                  DO NOT use two products from the SAME group together unless you have written veterinary authorisation.
                </strong>
                <br />
                Refer to product label and veterinary authorisation for all storage, handling and use instructions.
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="thead">Special Instructions or Contraindications</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-left">
              <td>{{ headers.combos_contra_indications }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table-bordered table">
          <tbody>
            <tr>
              <td style="width: 16.7%" class="thead">Veterinarian Name:</td>
              <td style="width: 16.7%">{{ headers.consult_vet }}</td>
              <td style="width: 16.7%" class="thead">Signature:</td>
              <td style="width: 16.7%"></td>
              <td style="width: 16.7%" class="thead">Date:</td>
              <td style="width: 16.7%">{{ headers.combo_date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { reportService, BACKEND_URL } from '@/_services'
import { get_dairy_season_start_year } from '@/_helpers/utils'

export default {
  props: ['farmId', 'displayName'],
  data() {
    return {
      headers: {},
      groups: {},
      combos: null,
      searching: false,
    }
  },
  computed: {
    hasData: function () {
      return Object.keys(this.headers).length > 0
    },
    exportUrl: function () {
      return `${BACKEND_URL}/reports/drug_combinations/export_pdf?farm_id=${this.farmId}&season_start_year=${this.seasonStartYear}`
    },
    seasonStartYear: function () {
      return get_dairy_season_start_year({ forWinterConsult: true })
    },
  },
  methods: {
    ...mapActions('alert', ['error']),
    onSubmit: function () {
      this.searching = true

      reportService
        .getDrugCombinationsReportData(this.farmId, this.seasonStartYear)
        .then((data) => {
          this.headers = data.headers
          this.groups = data.groups
          this.drugs_per_row = data.drugs_per_row
          this.combos = data.combos
          this.searching = false
        })
        .catch((error) => {
          this.error({ message: error.response.data.msg })
          this.searching = false
        })
    },
    resetData: function () {
      this.headers = {}
      this.groups = {}
    },
  },
}
</script>
<style>
.combos-table {
  border-radius: 5px;
}
.thead {
  background-color: rgb(54, 173, 122);
}
.lightblue {
  color: rgb(191, 220, 230);
}
</style>
